"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALCULATION_RESULT_PRECISION = void 0;
exports.CALCULATION_RESULT_PRECISION = 6;
//# sourceMappingURL=calculation-result-precision.js.map